// extracted by mini-css-extract-plugin
export default {"container":"QuizItem_container__G3kmG","title":"QuizItem_title__RGshz"};